import { Injectable } from '@angular/core';
import { DecimalPipe, DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { AppService } from './app.service';

@Injectable()
export class ChartService {
  numberPipe: DecimalPipe;
  datePipe: DatePipe;

  constructor(
    private appService: AppService,
    private translateService: TranslateService,
  ) {
    this.numberPipe = new DecimalPipe(this.appService.getLanguageAndCulture());
    this.datePipe = new DatePipe(this.appService.getLanguageAndCulture());
  }

  getChartBaseData() {
    return {
      datasets: [
        {
          label: null,
          fill: false,
          backgroundColor: '#5BBD72',
          borderColor: '#5BBD72',
        },
      ],
    };
  }

  getChartThumbnailOptions() {
    return {
      layout: {
        margin: 0,
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        }
      },
      plugins: {
        datalabels: {
          display: false,
        }
      },
      scales: {
        xAxes: [{
          ticks: {
            display: false,
            drawOnChartArea: false,
            drawTicks: false
          },
          gridLines: {
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
            color: 'transparent'
          }
        }],
        yAxes: [{
          ticks: {
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          gridLines: {
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
            color: 'transparent'
          }
        }]
      },
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
    };
  }

  getChartOptions() {
    return {
      plugins: {
        datalabels: {
          display: false,
          align: 'end',
          anchor: 'end',
          font: {
            size: 10,
          },
          offset: 5,
          backgroundColor: 'white',
          borderColor: 'rgba(0,0,0,.2)',
          borderWidth: 1,
          borderRadius: 3,
          formatter: (value, context) => {
            return this.numberPipe.transform(value) + (context.dataset.symbol || '');
          }
        }
      },
      tooltips: {
        mode: 'index',
        callbacks: {
          label: (obj, data) => {
            return (
              (data.datasets[obj.datasetIndex].label || '')
              + ' : '
              + this.numberPipe.transform(obj.yLabel)
              + (data.datasets[obj.datasetIndex].symbol || '')
            );
          }
        }
      },
      responsive: true,
      layout: {
        padding: {
          top: 25,
          bottom: 5
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            paddingTop: 30
          },
          ticks: {
            beginAtZero: true,
            padding: 10,
            callback: (value) => {
              return this.numberPipe.transform(value);
            }
          }
        }]
      }
    };
  }

  getLabels(granularity, string: any) {
    if (granularity === 'daily') {
      return this.getDayFromDate(string);
    } else {
      return this.getMonthFromDate(string);
    }
  }

  getDayFromDate(string) {
    const date = new Date(string);
    const formatted = this.datePipe.transform(date, 'shortDate');

    return formatted;
  }

  getMonthFromDate(string) {
    const date = new Date(string);
    const month = date.getMonth();
    const i18nMonths = Object.values(this.translateService.instant('shared.date.month')).map((f: any) => f());

    return i18nMonths[month];
  }
}
